module.exports = __webpack_public_path__ + "static/media/07.9b759efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/07.jpg
// module id = 569
// module chunks = 0